import { MessageBox } from 'element-ui';
import companyInfo from "@/constant/companyInfo";
export default {
    showConfirm(content, confirmCallback, cancelCallback, title = `Confirm`, color = 'blue') {
        this.showCustomWarning(title, content, confirmCallback, cancelCallback);
        //this.baseMessage("confirm", content, confirmCallback, cancelCallback, title, color, 'question');
    },
    showMessage(content, callback = null, title = `Infomation`, color = 'blue') {
        this.showCustomSuccess(title, content, callback);
        //this.baseMessage("alert", content, callback, null, title, color, 'info');
    },
    showError(content, callback = null, title = `Error`, color = 'red') {
        //let errorMsg = `${content}`;
        //let footerMsg = `<hr/>If you're still having issues, please contact us. Thankyou !`;
        //this.baseMessage("alert", errorMsg, callback, null, title, color, 'error', footerMsg);
        this.showCustomError(title, content, callback);
    },
    baseMessage(type = "alert", content, confirmCallback = null, cancelCallback = null, title, color, icon, footer = null) {
        let contentMsg = `<div class="dialog-content-msg d-flex">`;
        contentMsg += `<div class="msg-icon mr-3"><img class="dialog-msg-icon" 
                            style="width: 5rem;"
                            src="/static/image/${icon}.svg" /></div>`;
        contentMsg += `<div class="msg-content class="flex-full">`;
        contentMsg += `<div><h4><strong>${title}</strong></h4></div>`;
        contentMsg += `${content}<br>`;
        contentMsg += `</div></div>`;
        if (footer !== null) {
            contentMsg += `<div>${footer}<//div>`;
        }
        switch (type) {
            case "confirm":
                $.confirm({
                    title: false,
                    type: color,
                    columnClass: 'medium',
                    content: contentMsg,
                    buttons: {
                        confirm: {
                            text: '&nbsp;<i class="far fa-check-circle"></i>&nbsp;&nbsp; Confirm!&nbsp;&nbsp;',
                            btnClass: 'btn-primary mr-1',
                            action: confirmCallback
                        },
                        cancel: cancelCallback,
                    }
                });
                return;
            case "alert":
                $.alert({
                    title: false,
                    type: color,
                    columnClass: 'medium',
                    content: contentMsg,
                    buttons: {
                        heyThere: {
                            text: '&nbsp;<i class="far fa-check-circle"></i>&nbsp;&nbsp; OK!&nbsp;&nbsp;',
                            btnClass: 'btn-primary', // class for the button
                        }
                    }
                });
                return;
        }

    },
    onError(errorData, type, area) {
        let errorMsg = "";
        console.log("errorData", errorData);
        if (errorData.message !== null && errorData.message !== '') {
            errorMsg += `${errorData.message}`;
        } else {
            errorMsg += `Sorry, something when wrong. Please try again later.<br>`;
        }
        this.showCustomError(`Failed`, errorMsg);
        //this.showError(errorMsg, null);
    },
    on500Error(errorData) {
        if (!errorData.status === 500) {
            let errorMsg = "";
            if (errorData.message !== null && errorData.message !== '') {
                errorMsg += `${errorData.message}.<br>`;
            } else {
                errorMsg += `Sorry, something when wrong. Please try again later.<br>`;
            }
            this.showCustomError(`Failed`, errorMsg);
        }
    },


    // Dialog Element
    getDialogContentHTML(content, icon) {
        return `
            <div>
                <div class="d-flex flex-row">
                    <div class="col-2 p-0"><img src="/static/image/${icon}.svg" height="50" />
                    </div>
                    <div class="p-0 col-10 responsive-dialog position-relative">
                        <div style="color: #212121; font-weight: 500; margin-bottom: 2.5rem;" class="position-relative">
                            <div>${content}</div> 
                        </div>
                    </div>
                </div>
            </div>
            `
    },
    // Warning
    showCustomWarning(title, content, confirmAction, cancelAction, confirmButtonText, cancelButtonText, disabledCancelButton) {
        if (title === undefined || title === null || title === '') {
            title = 'Waring';
        }
        if (content === undefined || content === null || content === '') {
            content = 'Are you sure want action this?';
        }
        if (cancelButtonText === undefined || cancelButtonText === null || cancelButtonText === '') {
            cancelButtonText = '\xa0\xa0\xa0Cancel\xa0\xa0\xa0';
        }
        if (confirmButtonText === undefined || confirmButtonText === null || confirmButtonText === '') {
            confirmButtonText = '\xa0\xa0\xa0OK\xa0\xa0\xa0';
        }
        if (disabledCancelButton === undefined || disabledCancelButton === null || disabledCancelButton === '') {
            disabledCancelButton = true;
        }
        let icon = "notification-warning";
        MessageBox.confirm(this.getDialogContentHTML(content, icon), title, {
            dangerouslyUseHTMLString: true,
            cancelButtonText: cancelButtonText,
            confirmButtonText: confirmButtonText,
            closeOnPressEscape: false,
            closeOnClickModal: false,
            roundButton: true,
            showCancelButton: disabledCancelButton,
        }).then(() => {
            if (confirmAction) confirmAction();
        }).catch(() => {
            if (cancelAction) cancelAction();
        });
    },

    // Confirm
    showCustomConfirm(title, content, confirmAction, cancelAction) {
        if (title === undefined || title === null || title === '') {
            title = 'Confirm';
        }
        if (content === undefined || content === null || content === '') {
            content = 'Are you sure want action this?';
        }

        let icon = "notification-confirm";
        MessageBox.confirm(this.getDialogContentHTML(content, icon), title, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '\xa0\xa0\xa0OK\xa0\xa0\xa0',
            cancelButtonText: 'Cancel',
            closeOnPressEscape: false,
            closeOnClickModal: false,
            roundButton: true,
        }).then(() => {
            if (confirmAction) confirmAction();
        }).catch(() => {
            if (cancelAction) cancelAction();
        });
    },

    // Success
    showCustomSuccess(title, content, callback) {
        if (title === undefined || title === null || title === '') {
            title = 'Success';
        }
        if (content === undefined || content === null || content === '') {
            content = 'Thank you.';
        }
        let icon = "notification-success";
        MessageBox.alert(this.getDialogContentHTML(content, icon), title, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '\xa0\xa0\xa0OK\xa0\xa0\xa0',
            closeOnPressEscape: false,
            closeOnClickModal: false,
            roundButton: true,
            callback: action => {
                if (callback) callback();
            }
        });
    },

    // Error
    showCustomError(title, content, callback) {
        if (title === undefined || title === null || title === '') {
            title = 'Error';
        }
        if (content === undefined || content === null || content === '') {
            content = 'An unknown error has occurred, please try again later or contact support. Thank you.';
        }
        let icon = "notification-error";

        MessageBox.alert(this.getDialogContentHTML(content, icon), title,
            {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '\xa0\xa0\xa0OK\xa0\xa0\xa0',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                roundButton: true,
                callback: action => {
                    if (callback) callback();
                }
            });
    },

    // Unkown error
    showUnknowError(title, content, callback) {
        if (title === undefined || title === null || title === '') {
            title = 'Oops!';
        }
        if (content === undefined || content === null || content === '') {
            content = 'An unknown error has occurred, please try again later or contact support. Thank you.';
        }
        let icon = "notification-error";
        MessageBox.alert(this.getDialogContentHTML(content, icon), title, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '\xa0\xa0\xa0OK\xa0\xa0\xa0',
            closeOnPressEscape: false,
            closeOnClickModal: false,
            roundButton: true,
            callback: action => {
                if (callback) callback();
            }
        });
    }
}